export default __webpack_public_path__ + "static/media/lorenzXY.305805b9.svg";